import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      background: (props: { isBackgroundAccented: boolean; autoDimensions: boolean }) =>
        props.isBackgroundAccented ? BackgroundColors.base : 'initial',
      '&.primary': {
        display: 'flex',
        paddingTop: 108,
        paddingBottom: 108,

        [mediaQuery(1023)]: {
          padding: [Spacings.s64, Spacings.s0, Spacings.s72],
        },
        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          padding: [Spacings.s64, Spacings.s0, Spacings.s56],
        },
      },
      '&.secondary': {
        display: 'flex',
        padding: [Spacings.s64, Spacings.s0],

        [mediaQuery(1365)]: {
          padding: [Spacings.s40, Spacings.s0],
        },
      },
      '&.carousel': {
        display: 'flex',
      },
      '&.templates': {
        display: 'flex',
        padding: [Spacings.s64, Spacings.s0],
      },
      '&.auto-dimensions': {
        display: 'flex',
        height: 'fit-content',
        padding: [Spacings.s64, Spacings.s0],

        [mediaQuery(1365)]: {
          padding: [Spacings.s40, Spacings.s0],
        },
      },
      '&.brands': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: Spacings.s0,
        width: '100%',
        height: '100%',
      },
    },
  }),
  {
    name: 'banner-centered',
  },
);

export default useStyles;
